import { render, staticRenderFns } from "./DefaultFieldWidget.vue?vue&type=template&id=1fdecb04"
import script from "./DefaultFieldWidget.vue?vue&type=script&lang=js"
export * from "./DefaultFieldWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports